module.exports = __webpack_public_path__ + "img/precipitation.a8fc17cd.svg";